export default "__VITE_ASSET__duN_u3x5__"